import { render, staticRenderFns } from "./notRecord.vue?vue&type=template&id=7ba3962a&scoped=true"
import script from "./notRecord.vue?vue&type=script&lang=js"
export * from "./notRecord.vue?vue&type=script&lang=js"
import style0 from "./notRecord.vue?vue&type=style&index=0&id=7ba3962a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba3962a",
  null
  
)

export default component.exports